import { ITarefa } from "../../../types/tarefa";

export interface IResultadoValidacao {
    texto: String,
    valido: boolean
}

export function validarTipo(tarefa: ITarefa): boolean {
    return tarefa.tipo !== "";
}

export function validarNome(tarefa: ITarefa): boolean {
    return tarefa.nome !== "";
}

export function validarGrupo(tarefa: ITarefa): boolean {
    if (tarefa.grupo) 
        return tarefa.grupo.nome !== "";
    else
        return false;
}

export function validarAgendamento(tarefa: ITarefa): boolean {
    return true;
}

export function validarDefinicao(tarefa: ITarefa): boolean {
    if (tarefa.tipo === "SQLServer" || tarefa.tipo === "Sybase" || tarefa.tipo === "Postgres" || tarefa.tipo === "CheckDB")
        return validarSQLServer(tarefa);
    else if (tarefa.tipo === "Arquivos")
        return validarArquivos(tarefa);
    else if (tarefa.tipo === "Bat")
        return true;

    return false;
}

export function validarArquivos(tarefa: ITarefa): boolean {
    if (!tarefa.arquivos)
        return false;

    const arquivos = tarefa.arquivos;

    if (arquivos.pastaOrigem === "")
        return false;
    else if (arquivos.pastaDestino === "")
        return false;
    else
        return true;
}

export function validarSQLServer(tarefa: ITarefa): boolean {
    if (!tarefa.configBancoDados)
        return false;

    const sqlServer = tarefa.configBancoDados;

    if (sqlServer.tipo === "")
        return false;
    else if (sqlServer.servidor === "")
        return false;
    else if (sqlServer.porta <= 0)
        return false;
    else if (sqlServer.bancoDados === "")
        return false;
    else if (sqlServer.usuario === "")
        return false;
    else if (sqlServer.descricao === "")
        return false;
    else
        return true;
}

export function validarPosExecucao(tarefa: ITarefa): boolean {
    return true;
}